import PropTypes from "prop-types";
import React from "react";
import ObjectUtils, { coalesce } from "../../../../../utils/ObjectUtils";
import { findAnswer, makeAnswer } from "../../../../../utils/QuestionUtils";
import DatePickerComponent from "../../../../common/datePicker/DatePicker";

const { getDeepProperty } = ObjectUtils;

const DateRenderer = ({ disabled, question, collection, row, column, setQuestionAnswer }) => {
  const answer = findAnswer(collection, { row, column });
  const textValue = coalesce(getDeepProperty(answer, "value"), "");

  const handleChange = (value) => {
    if (typeof value !== "string") {
      setQuestionAnswer(question, makeAnswer(value.toISOString(), row, column));
    }
  };

  return (
    <DatePickerComponent
      disabled={disabled}
      dateFormat={question.dateFormat}
      value={textValue}
      onChange={handleChange}
    />
  );
};

DateRenderer.propTypes = {
  disabled: PropTypes.bool,
  question: PropTypes.object.isRequired,
  collection: PropTypes.array,
  setQuestionAnswer: PropTypes.func.isRequired,
  row: PropTypes.object,
  column: PropTypes.object
};

export default React.memo(DateRenderer);
